export const PRIVACY_POLICY_DOC_URL =
  'https://thanx.s3.us-east-1.amazonaws.com/uploads/doc/privacy_policy.docx'
export const PRIVACY_POLICY_DOC_FILENAME = 'privacy_policy.docx'
export const TERMS_OF_SERVICE_DOC_URL =
  'https://thanx.s3.us-east-1.amazonaws.com/uploads/doc/terms_of_service.docx'
export const TERMS_OF_SERVICE_DOC_FILENAME = 'terms_of_service.docx'
